// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----Team-module---container---3GTmm","content":"src-components----Team-module---content---1cZCF","team":"src-components----Team-module---team---1zUbB","news":"src-components----Team-module---news---1tJ1X","newsContainer":"src-components----Team-module---newsContainer---1Ns8E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Team.module.css
// module id = 135
// module chunks = 35783957827783 43201937662106